// import Layout from '@/layout'

const registerRouter = {
  path: '',
  component: () => import('@/views/register/index'),
  redirect: 'register',
  name: '企业注册',
  meta: {
    title: '企业注册',
    icon: 'el-icon-s-home'
  },
  children: [
    {
      path: 'register',
      name: '企业注册',
      meta: {
        title: '企业注册'
      },
      component: () => import('@/views/register/index')
    }

  ]
}

export default registerRouter
